import { FormEvent, ReactNode } from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { BottomButtons } from '@/shared/view/BottomButtons';
import { Section } from '@/shared/view/Section';
import { Selection } from '@/shared/view/Selection';
import { Button } from '@src-common/view/adapters/Button';

import s from './styles.module.css';

interface FormShape {
  vehicle: string;
}

interface Item {
  value: string;
  title: string;
  description?: ReactNode;
}

interface IProps {
  items: Item[];
  onSubmit: (e: FormEvent) => void;
  isSubmitting: boolean;
  isValid: boolean;
  control: Control<FormShape>;
}

const Form = ({ items, onSubmit, isSubmitting, isValid, control }: IProps) => (
  <form onSubmit={onSubmit}>
    <Section>
      <div className={s.items}>
        {items.map(item => (
          <Selection
            name="vehicle"
            control={control}
            key={item.value}
            value={item.value}
            title={item.title}
            description={item.description}
            rules={{ required: true }}
          />
        ))}
      </div>
      <div className={s.note}>
        <FormattedMessage
          defaultMessage="* From 1st date of registration"
          id="wbvIHX"
          description="Maximum age note"
        />
      </div>
    </Section>
    <BottomButtons>
      <Button type="submit" isPending={isSubmitting} isDisabled={!isValid}>
        <FormattedMessage
          defaultMessage="NEXT"
          id="6jg2Fp"
          description="OnBoarding next button text"
        />
      </Button>
    </BottomButtons>
  </form>
);

export { Form };
export type { FormShape, Item };
